import styled from 'styled-components';

export const CourseCommentsContainer = styled.div``;
